import React, { FunctionComponent, useContext } from "react";
import { useQueryParams, useTranslate } from "../../helpers";
import { withRouter, RouteComponentProps } from "react-router";
import { AppPage } from "../../components";
import { Card, Button } from "@cmsgov/ds-medicare-gov";
import routes from "../../app/routes";
import { AppStore } from "../../app/store";
import { ActionType } from "../../@types";
import { CoverageType } from "../QuestionRoutingPage/types";

const CoverageWizardOptionsPage: FunctionComponent<RouteComponentProps> = props => {
  useQueryParams(props);
  const t = useTranslate();

  const { dispatch } = useContext(AppStore.AppContext);

  const chooseCoverage = (coverage: CoverageType): void => {
    dispatch({
      type: ActionType.UPDATE_CW_COVERAGE,
      payload: coverage,
    });
    props.history.push(routes.coverageWizard.info);
  };

  return (
    <AppPage
      heading={t("cw.your_options")}
      bannerClassName="ds-u-padding-bottom--0"
      outerClassName="ds-u-md-display--flex ds-u-md-flex-direction--column ds-u-md-align-items--center"
    >
      <>
        <p className="ds-u-md-text-align--center">{t("cw.options.two_ways")}</p>
        <p className="ds-u-display--none ds-u-md-display--block ds-u-md-text-align--center">
          {t("cw.options.choose_option")}
        </p>
        <div className="ds-u-md-display--flex ds-u-md-margin-top--5">
          <Card className="CoverageWizardOptionsPage__card">
            <h2>{t("cw.options.original_medicare")}</h2>
            <ul className="ds-c-list">
              <li>{t("cw.options.om.part_a_b")}</li>
              <li>{t("cw.options.om.drug_coverage")}</li>
              <li>{t("cw.options.om.medigap")}</li>
            </ul>
            <Button
              className="CoverageWizardOptionsPage__omDesktopButton ds-u-display--none ds-u-md-display--block ds-c-button ds-c-button--primary-alt mct-u-full-width ds-u-margin-top--2"
              size="big"
              onClick={(): void =>
                chooseCoverage(CoverageType.OriginalMedicare)
              }
            >
              {t("cw.options.original_medicare")}
            </Button>
          </Card>
          <Card className="CoverageWizardOptionsPage__card">
            <h2>{t("cw.options.mapd")}</h2>
            <ul className="ds-c-list">
              <li>{t("cw.options.mapd.alternative")}</li>
              <li>{t("cw.options.mapd.bundled")}</li>
              <li>{t("cw.options.mapd.extra_benefits")}</li>
            </ul>
            <Button
              className="ds-u-display--none ds-u-md-display--block ds-c-button ds-c-button--primary-alt mct-u-full-width ds-u-margin-top--2"
              size="big"
              onClick={(): void => chooseCoverage(CoverageType.MAPD)}
            >
              {t("cw.options.mapd")}
            </Button>
          </Card>
        </div>
        <p className="ds-u-md-display--none ds-u-margin-top--4">
          {t("cw.options.choose_option")}
        </p>
        <Button
          className="ds-u-md-display--none ds-c-button ds-c-button--primary-alt mct-u-full-width ds-u-margin-top--2"
          size="big"
          onClick={(): void => chooseCoverage(CoverageType.OriginalMedicare)}
        >
          {t("cw.options.original_medicare")}
        </Button>
        <Button
          className="ds-u-md-display--none ds-c-button ds-c-button--primary-alt mct-u-full-width ds-u-margin-top--2"
          size="big"
          onClick={(): void => chooseCoverage(CoverageType.MAPD)}
        >
          {t("cw.options.mapd")}
        </Button>
      </>
    </AppPage>
  );
};

export default withRouter(CoverageWizardOptionsPage);
